import { Button } from '@pique/component/ui/button';
import { useI18n } from '@pique/i18n';
import { useCallback } from 'react';

import { PiqueLogo } from '../auth-components/pique-logo';
import { DesktopNavbar } from './desktop-navbar';
import * as styles from './index.css';
import { MobileNavbar } from './mobile-navbar';

export const AffineOtherPageLayout = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const t = useI18n();

  const openDownloadLink = useCallback(() => {
    open(runtimeConfig.downloadUrl, '_blank');
  }, []);

  return (
    <div className={styles.root}>
      <div className={styles.topNav}>
        <a href="/" rel="noreferrer" className={styles.affineLogo}>
          <PiqueLogo />
        </a>

        <DesktopNavbar />
        <Button
          onClick={openDownloadLink}
          className={styles.hideInSmallScreen}
        >
          {t['com.pique.auth.open.affine.download-app']()}
        </Button>
        <MobileNavbar />
      </div>

      {children}
    </div>
  );
};
